import { render, staticRenderFns } from "./TenantNew.vue?vue&type=template&id=0b681bb6&"
import script from "./TenantNew.vue?vue&type=script&lang=ts&"
export * from "./TenantNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports